import type { AerieEndedEvent } from '@shefira/shared';

import './aerie.css';
import { endedNote, endedTitle, exitCountdown } from './aerie-text.js';

/**
 * The end of Shefira's fight (ADR 0068), for everyone in the Aire: won,
 * fled with the sword in her flank, or lost, and how long before the Aire
 * sends everyone back to La Brèche. The server walks them out; this only
 * counts down. A second word of the same end (a victor whose weekly loot was
 * had) only changes the note.
 */
export class AerieResult {
  private readonly root: HTMLElement;
  private readonly title: HTMLElement;
  private readonly note: HTMLElement;
  private readonly exit: HTMLElement;
  private timer: number | undefined;
  private exitAt = 0;
  private outcome: AerieEndedEvent['outcome'] | null = null;

  constructor() {
    this.root = document.createElement('div');
    this.root.className = 'aerie-ended';
    this.root.hidden = true;
    this.root.setAttribute('role', 'status');
    this.title = document.createElement('p');
    this.title.className = 'aerie-ended__title';
    this.note = document.createElement('p');
    this.note.className = 'aerie-ended__note';
    this.exit = document.createElement('p');
    this.exit.className = 'aerie-ended__exit';
    this.root.append(this.title, this.note, this.exit);
    document.body.append(this.root);
  }

  show(ended: AerieEndedEvent): void {
    const again = this.outcome === ended.outcome;
    this.outcome = ended.outcome;
    this.root.dataset.outcome = ended.outcome;
    this.title.textContent = endedTitle(ended.outcome);
    this.note.textContent = endedNote(ended);
    // The loot's word comes with no delay of its own: the first countdown goes on.
    if (!again || ended.exitInMs > 0) this.exitAt = Date.now() + ended.exitInMs;
    this.root.hidden = false;
    this.tick();
  }

  private tick(): void {
    window.clearTimeout(this.timer);
    const left = Math.max(0, Math.ceil((this.exitAt - Date.now()) / 1000));
    this.exit.textContent = exitCountdown(left);
    this.exit.hidden = left === 0;
    if (left > 0) {
      this.timer = window.setTimeout(() => {
        this.tick();
      }, 250);
    }
  }

  destroy(): void {
    window.clearTimeout(this.timer);
    this.root.remove();
  }
}
